import { render, staticRenderFns } from "./leftNavOfSpm.vue?vue&type=template&id=aabaaec6&scoped=true"
import script from "./leftNavOfSpm.vue?vue&type=script&lang=js"
export * from "./leftNavOfSpm.vue?vue&type=script&lang=js"
import style0 from "./leftNavOfSpm.vue?vue&type=style&index=0&id=aabaaec6&lang=scss&scoped=true"
import style1 from "./leftNavOfSpm.vue?vue&type=style&index=1&id=aabaaec6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabaaec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aabaaec6')) {
      api.createRecord('aabaaec6', component.options)
    } else {
      api.reload('aabaaec6', component.options)
    }
    module.hot.accept("./leftNavOfSpm.vue?vue&type=template&id=aabaaec6&scoped=true", function () {
      api.rerender('aabaaec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newMenu/leftNavOfSpm.vue"
export default component.exports